
module.exports = {
  validate(rule) {
    return !!rule.idType && rule[`${rule.idType}s`] instanceof Array
  },

  test({ params, rule }) {
    const id = params[rule.idType];
    const normalizedId = id && id.toString().toLowerCase();
    return rule[`${rule.idType}s`].some(idInList => (idInList && idInList.toString().toLowerCase()) === normalizedId);
  }
};
